// extracted by mini-css-extract-plugin
export var active = "_25-d";
export var blink = "_25-e";
export var container = "_25-5";
export var controls = "_25-0";
export var controlsRight = "_25-1";
export var fakeCursor = "_25-c";
export var hidden = "_25-b";
export var quillContainerSmall = "_25-7";
export var quillEditor = "_25-6";
export var quillEditorSmall = "_25-8";
export var quillFormatButtons = "_25-a";
export var quillToolbar = "_25-9";
export var removePadding = "_25-2";
export var state = "_25-3";
export var stateTitle = "_25-4";